'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// eslint-disable-line import/no-extraneous-dependencies


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Hex
var hex = (0, _glamor.css)({
  boxSizing: 'border-box',
  display: 'flex',
  transform: 'translateZ(0)',
  WebkitTransform: 'translateZ(0)',
  padding: '6px',
  paddingBottom: '0',

  '& > div': {
    width: '100%'
  },

  '@media (min-width: 550px)': {
    padding: '15px'
  },

  '@media (min-width: 768px)': {
    flex: '0 0 50%',
    maxWidth: '50%',
    boxShadow: '0 1px 0 0 #f6f2f8',
    WebkitFlex: '0 0 50%',

    '&:nth-child(4)': {
      boxShadow: 'none'
    },

    '&:nth-child(5)': {
      boxShadow: 'none'
    },

    '&:nth-child(6)': {
      boxShadow: 'none'
    }
  }
});
var hexClass = hex.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Grid
var grid = (0, _glamor.css)({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  WebkitBoxOrient: 'horizontal',
  WebkitBoxDirection: 'normal',
  WebkitFlexDirection: 'row',
  WebkitBoxLines: 'multiple',
  WebkitFlexWrap: 'wrap',
  WebkitBoxPack: 'justify',
  WebkitJustifyContent: 'space-between'
});
var gridClass = grid.toString();

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------- Components
// ------------------------------------------------------------------------------
/* eslint-disable prefer-template */
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Hex
/**
 * Hex
 */
var Hex = function Hex(props) {
  return _react2.default.createElement(
    'div',
    {
      className: '' + hexClass + (props.className ? ' ' + props.className : ''),
      style: _extends({}, props.style)
    },
    _react2.default.createElement(
      'div',
      null,
      props.children
    )
  );
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Grid
/**
 * Grid
 */
var TetraGrid = function TetraGrid(props) {
  return _react2.default.createElement(
    'div',
    {
      className: '' + gridClass + (props.className ? ' ' + props.className : ''),
      style: _extends({}, props.style)
    },
    props.children
  );
};
/* eslint-enable prefer-template */

// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Typings
// ------------------------------------------------------------------------------
Hex.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
} : {};

Hex.defaultProps = {
  className: '',
  style: {}
};

TetraGrid.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
} : {};

TetraGrid.defaultProps = {
  style: {},
  className: ''
};

// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
var ComposedComponent = {
  TetraGrid: TetraGrid,
  Hex: Hex
};

exports.default = ComposedComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/components/lib/TetraGrid.js
// module id = 434
// module chunks = 168707334958949